import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

import { SlideUpCard } from 'src/shared/components/SlideUpCard';

import { Menu as MenuConstants } from '../../../constants';
import { CardHeader } from '../CardHeader';
import { Menu } from '../Menu';

interface PropTypes {
  headerText: string | null;
  closeMenu: () => void;
  menu: MenuConstants | null;
}

const DesignCard = ({ closeMenu, menu, headerText }: PropTypes) => (
  <SlideUpCard closeMenu={closeMenu}>
    <CardHeader
      headerText={headerText}
      leftActionHandler={closeMenu}
      leftIcon={faChevronLeft}
    />
    <Menu menu={menu} />
  </SlideUpCard>
);

export { DesignCard };
